import { render, staticRenderFns } from "./index.vue?vue&type=template&id=527197bc&scoped=true&"
import script from "./index.vue?vue&type=script&setup=true&lang=js&"
export * from "./index.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=527197bc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527197bc",
  null
  
)

export default component.exports